<div
  [matTooltip]="'showHistory' | i18n"
  matTooltipPosition="above">
  <ng-container [ngSwitch]="invitee?.status">
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.OPEN"
      class="size-20 text-icon-grey"
      svgIcon="clock"
      data-cy="invitee-status-OPEN"></mat-icon>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.AVAILABLE"
      class="size-20 text-icon-success"
      svgIcon="check"
      data-cy="invitee-status-AVAILABLE"></mat-icon>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.UNAVAILABLE"
      class="size-20 text-icon-error"
      svgIcon="close"
      data-cy="invitee-status-UNAVAILABLE"></mat-icon>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.DECLINED"
      class="size-20 text-icon-error"
      svgIcon="close-rejected-remove-circle"
      data-cy="invitee-status-DECLINED"></mat-icon>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.CANCELED"
      class="size-20 text-icon-error"
      svgIcon="star-rejected-storno-filled"
      data-cy="invitee-status-CANCELED"></mat-icon>
    <ng-container *ngSwitchCase="InviteeStatusEnum.BOOKED">
      <mat-icon
        *ngIf="invitee?.transferredFrom"
        class="size-20"
        svgIcon="star-booked-rebook-filled"
        data-cy="invitee-status-BOOKED-transferred"></mat-icon>
      <mat-icon
        *ngIf="!invitee?.transferredFrom"
        class="size-20 text-icon-warning"
        svgIcon="star-filled"
        data-cy="invitee-status-BOOKED"></mat-icon>
    </ng-container>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.POSSIBLE_CANDIDATE"
      class="size-20 text-icon-success"
      svgIcon="star-check-outline"
      data-cy="invitee-status-POSSIBLE_CANDIDATE"></mat-icon>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.TRANSFERRED"
      class="size-20"
      svgIcon="star-rejected-storno-rebook-filled"
      data-cy="invitee-status-TRANSFERRED"></mat-icon>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.WORKING"
      class="size-20 text-icon-error"
      svgIcon="suitcase-job-fill"
      data-cy="invitee-status-WORKING"></mat-icon>
    <mat-icon
      *ngSwitchCase="InviteeStatusEnum.PARTIAL_AVAILABLE"
      class="size-20 text-icon-success"
      svgIcon="check-brackets-partial-accept"
      data-cy="invitee-status-PARTIAL_AVAILABLE"></mat-icon>
  </ng-container>
</div>
